/* 
  Filter reports table data based on the category variable
  < input = category, data >
  < input = data > (possibly filtered if category selected)
 */

export function filterDataByCategory(category, data) {
  
  // Remove items with an empty category
  const filteredDataWithoutEmptyCategories = data.filter(
    (item) => item["Category (per property)"] !== ""
  );

  // Return all data if "All" is selected
  if (category === "All") {
    return filteredDataWithoutEmptyCategories;
  } else {
    // Filter based on the category if selected
    return filteredDataWithoutEmptyCategories.filter(
      (item) => item["Category (per property)"] === category
    );
  }
}
